import { createReducer, on } from "@ngrx/store";
import * as CategoryActions from "./category.actions";
import { CategoryState, initialCategoryState } from "./category.state";

export const CategoriesReducer = createReducer(
  initialCategoryState,

  // ===== LOAD CATEGORIES =====
  on(CategoryActions.loadCategories, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CategoryActions.loadCategoriesSuccess, (state, { categories }) => ({
    ...state,
    categories, // Directly set the array (no adapter.setAll)
    loading: false,
  })),
  on(CategoryActions.loadCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ===== LOAD SINGLE CATEGORY =====
  on(CategoryActions.loadCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  // Not needed if you don't track a single category in state
  on(CategoryActions.loadCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ===== CREATE CATEGORY =====
  on(CategoryActions.createCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CategoryActions.createCategorySuccess, (state, { category }) => ({
    ...state,
    categories: [...state.categories, category], // Manually add to array
    loading: false,
  })),
  on(CategoryActions.createCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ===== UPDATE CATEGORY =====
  on(CategoryActions.updateCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CategoryActions.updateCategorySuccess, (state, { category }) => ({
    ...state,
    categories: state.categories.map(
      (c) => (c.id === category.id ? category : c) // Manual update
    ),
    loading: false,
  })),
  on(CategoryActions.updateCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ===== DELETE CATEGORY =====
  on(CategoryActions.deleteCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CategoryActions.deleteCategorySuccess, (state, { id }) => ({
    ...state,
    categories: state.categories.filter((c) => c.id !== id), // Manual delete
    loading: false,
  })),
  on(CategoryActions.deleteCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CategoryActions.checkCategoryNameSuccess, (state, { exists }) => ({
    ...state,
    nameExists: exists,
  })),

  on(CategoryActions.checkCategoryCodeSuccess, (state, { exists }) => ({
    ...state,
    codeExists: exists,
  })),

  on(CategoryActions.checkCategoryNameFailure, (state, { error }) => ({
    ...state,
    nameExists: null,
    nameCheckError: error,
  })),

  on(CategoryActions.checkCategoryCodeFailure, (state, { error }) => ({
    ...state,
    codeExists: null,
    codeCheckError: error,
  }))
);
